export default "__VITE_ASSET__61db305f__"